module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"{name} :: แก้ไขข้อมูลอะไหล่","page.description":"แก้ไขข้อมูลของอะไหล่ SKU : {name} ในระบบ","update_part.success":"ทำการแก้ไขข้อมูลอะไหล่ \\"SKU : {name}\\" ในระบบเรียบร้อย","update_part.confirm.title":"ยืนยันการแก้ข้อมูลอะไหล่","update_part.confirm.message":"คุณต้องการแก้ไขข้อมูลอะไหล่นี้ ?"}}')
  delete Component.options._Ctor
}
